import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { WebSocketService } from '../../../../client/app/server-communication/services/websocket.service';
import { WebSocketMessageType } from '../../../../model/web-socket-message';
import FlightsActions from './flights.action-types';

@Injectable()
export class FlightsEffects {
    constructor(private readonly actions$: Actions, private readonly webSocketService: WebSocketService) {}

    // Docking Context
    requestFlights$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(FlightsActions.requestFlights),
                map(action => action.centerlineIds),
                tap(centerlineIds => this.webSocketService.sendMessage(WebSocketMessageType.Flights, { centerlineIds }))
            ),
        { dispatch: false }
    );
}
